import React, { useState } from 'react'

import { Tooltip, Modal } from 'antd'
import { Button } from '@digital/ui'
import { EStatusAprovacaoSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto'
import { encerrarSolicitacaoNaoPrevisto, reabrirSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao'

interface Props {
    justificativa: string
    responsavel: string
    statusId: string
    statusAprovacaoId: string
    id: string
    exibirModal: boolean;
    setExibirModal: (exibirModal: boolean)
}

const ModalReabrirFinalizarSolicitacao = (props: Props) => {
    const { justificativa, responsavel, statusAprovacaoId, id } = props
    const situacao = statusAprovacaoId == EStatusAprovacaoSolicitacaoNaoPrevisto.Reprovado ? "reprovada" :
        statusAprovacaoId == EStatusAprovacaoSolicitacaoNaoPrevisto.NaoValidado ? "não validada" :
            "validada"

    const showModal = () => {
        props.setExibirModal(true)
    }

    const cancelModal = () => {
        props.setExibirModal(false)
    }

    const handleReabrir = () => {
        reabrirSolicitacaoNaoPrevisto(id).then(data => {
            if (data && data.valid) {
                cancelModal()
                window.open(`/naoPrevisto/solicitacao/${id}`)
            }
        })
    }

    const handleEncerrar = () => {
        Modal.confirm({
            title: 'Ao confirmar, esta solicitação será encerrada e a ação não poderá ser desfeita. Deseja continuar?',
            okText: 'Sim',
            onOk: () => encerrarSolicitacaoNaoPrevisto(id).then(data => {
                if (data && data.valid) {
                    cancelModal()
                    window.open(`/naoPrevisto/solicitacao/${id}`)
                }
            }),
            cancelText: 'Não',
            onCancel: () => { cancelModal() }
        })
    }

    return (
        <>
            {/* <Tooltip title="">
                <Button
                    id="mrn-btn-visualizar-solicitacao"
                    type="link"
                    icon="arrows-circled_up_right_2"
                    onClick={showModal}
                />
            </Tooltip> */}

            <Modal
                title="Justificativa"
                visible={props.exibirModal}
                onCancel={cancelModal}
                footer={<>
                    <Button
                        id="mrn-btn-reabrir-solicitacao"
                        type="success"
                        title='Reabrir'
                        onClick={handleReabrir}
                    />
                    <Button
                        id="mrn-btn-finalizar-solicitacao"
                        type="danger"
                        title='Finalizar'
                        onClick={handleEncerrar}
                    />
                </>
                }
            >
                <span>
                    A solicitacao foi {situacao} por {responsavel} devido {justificativa}. Qual ação deseja realizar?
                </span>
            </Modal>
        </>
    )
}

export default ModalReabrirFinalizarSolicitacao